import {useEffect, useState} from 'react';

const useDelay = (duration: number = 300) => {
  const [isDelaying, setIsDelaying] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsDelaying(false);
    }, duration);
    return () => {
      clearTimeout(timeout);
    };
  }, [duration]);

  return {isDelaying};
};

export default useDelay;
